import { render, staticRenderFns } from "./CopyProjectLeadsModal.vue?vue&type=template&id=6d75d674&"
import script from "./CopyProjectLeadsModal.vue?vue&type=script&lang=js&"
export * from "./CopyProjectLeadsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports